import React from 'react';
const Breadcrumb = function (options) {
    const { url } = options;
    return React.createElement("puk-breadcrumb", { url: url });
};
Breadcrumb.defaultProps = {
    url: window.location.href
};
export { Breadcrumb };
